import React from "react";
import "./EmeraldRealTimeAlerts.scss";

import { connect } from "react-redux";
import TradeAlertsAndSignals from "../TradeAlertsAndSignals";
import RealTimeTradeAlerts from "../../common/RealTimeTradeAlerts";

const EmeraldRealTimeAlerts = ({ themeMode }) => {
  return (
    <div className="emerald-real-time-alerts">
      <div className="emerald-real-time-alerts__left">
        <div className="emerald-real-time-trading-alerts-component">
          <div className="emerald-real-time-trading-alerts-title">
            Real-Time Trade Alerts on Telegram
          </div>
          <div className="emerald-real-time-trading-alerts-guide">
            <strong style={{ fontWeight: "700!important" }}>
              Emerald Income Alerts Telegram Channel
            </strong>{" "}
            is designed to make trading easier for beginners and more lucrative
            for experienced traders. Whether users want to copy an expert trader
            or build and monetise their existing trades. To access the channel,
            click the link below.
          </div>

          <a
            href="https://t.me/+WKhGeIKkzPE5YTZh"
            target="_blank"
            rel="noreferrer"
            className="platinum-program-telegram-button"
          >
            Join Telegram
          </a>

          <RealTimeTradeAlerts
            specificGuide="Here are 3 easy steps to setup your Telegram and access to Emerald Income Alerts Telegram Channel to receive real-time trade and movement notifications"
            productName="Emerald Income Alerts"
            telegramLink="https://t.me/+WKhGeIKkzPE5YTZh"
          />
        </div>
      </div>

      <div className="emerald-real-time-alerts__right">
        <TradeAlertsAndSignals
          themeMode={themeMode}
          url="https://t.me/+WKhGeIKkzPE5YTZh"
        />
      </div>
    </div>
  );
};

const stateToProps = (state) => ({
  themeMode: state.themeMode.themeMode,
});

export default connect(stateToProps, null)(EmeraldRealTimeAlerts);
